function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { createContext } from "react";
var VKContext = createContext();
export function withVK(Component) {
  return function VKComponent(props) {
    return React.createElement(VKContext.Consumer, null, function (vk) {
      return React.createElement(Component, _extends({}, props, {
        vk: vk
      }));
    });
  };
}
export default VKContext;